<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商品预配订单表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>输入搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.dbid"
                    placeholder="打标ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.box_no"
                    placeholder="容器号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.sku"
                    placeholder="SKU"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.order_sn"
                    placeholder="订单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.work_id"
                    placeholder="工单ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.create_admin"
                    placeholder="创建人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="status" label="">
                  <el-select v-model="form.status" placeholder="状态">
                    <el-option label="全部"></el-option>
                    <el-option
                      v-for="(item, k) in status"
                      :key="k"
                      :label="item"
                      :value="k"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预配时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button
                    style="background: #85ce61"
                    type="success"
                    @click="output"
                    >导出</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="dbid"
              label="打标ID"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="box_no"
              label="容器号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="SKU"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status"
              label="状态"
            ></el-table-column>
            <el-table-column align="center" prop="order_sn" label="预配订单号">
              <template slot-scope="scope">
                <span>{{ scope.row.order_sn }}</span>
                <span v-if="scope.row.is_spot === '1'" class="spot_order">
                  现</span
                >
                <span
                  v-if="scope.row.is_prior === '1'"
                  class="spot_order yellow"
                >
                  优</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="work_id"
              label="预配工单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_admin"
              label="创建人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="预配时间"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.pages"
            :page-size="50"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // if (!vm.resData) {
      vm.fetchData();
      // }
    });
  },
  data() {
    return {
      logpages: 0,
      logcurPage: 1,
      showBind: false,
      logData: [],
      logVisible: false,
      resData: null,
      form: {
        status: "",
        create_time: [],
        dbid: "",
        box_no: "",
        goods_name: "",
        goods_no: "",
        sku: "",
        work_id: "",
        create_admin: "",
        order_sn: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/PreAllot/listPreAllot",
      curPage: 1,
      filterFold: false,
      isAll: false,
      dialogFormVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.status = this.resData.status;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.spot_order {
  color: #f00;
  border: 1px solid;
  border-radius: 4px;
}

.yellow {
  color: #cbcb04;
}
</style>



// WEBPACK FOOTER //
// src/pages/preallot/preAllotList.vue